import actionTypes from './actiontypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'

const {
  REQUEST_CONTACT_LIST,
  RECEIVE_CONTACT_LIST,
  SERVER_ERROR_OCURED,
  REQUEST_LIST_DETAILS,
  RECEIVE_LIST_DETAILS
} = actionTypes

function hasErrored (bool) {
  return {
    type: SERVER_ERROR_OCURED,
    hasErrored: bool
  }
}

export function fetchContactList (token) {
  return function (dispatch) {
    dispatch({type: REQUEST_CONTACT_LIST})
    return fetch(`${config.URI}/api/v1/contacts`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({type: RECEIVE_CONTACT_LIST, contacts: res.data.contact})
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function createContactList (token, name) {
  return function (dispatch) {
    dispatch({type: REQUEST_CONTACT_LIST})
    const payload = {
      name
    }
    return fetch(`${config.URI}/api/v1/contacts`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchContactList(token))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function updateContactList (token, name, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_CONTACT_LIST})
    const payload = {
      name
    }
    return fetch(`${config.URI}/api/v1/contacts/${id}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchContactList(token))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function fetchListDetails (token, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_LIST_DETAILS})
    return fetch(`${config.URI}/api/v1/lists?contact_id=${id}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({type: RECEIVE_LIST_DETAILS, list: res.data.list})
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function deleteContactList (token, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_CONTACT_LIST})
    return fetch(`${config.URI}/api/v1/contacts/${id}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchContactList(token))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function addPerson (token, name, email, role, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_LIST_DETAILS})
    const payload = {
      name,
      email,
      role,
      contact_id: id
    }
    return fetch(`${config.URI}/api/v1/lists`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchListDetails(token, id))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function editPerson (token, name, email, role, listId, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_LIST_DETAILS})
    const payload = {
      name,
      email,
      role
    }
    return fetch(`${config.URI}/api/v1/lists/${listId}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchListDetails(token, id))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function deletePerson (token, listId, id) {
  return function (dispatch) {
    dispatch({type: REQUEST_LIST_DETAILS})
    return fetch(`${config.URI}/api/v1/lists/${listId}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchListDetails(token, id))
        } else if (res.errors) {
          console.error(res.errors)
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function csvUpload (token, file, contactId, validation) {
  return function (dispatch, getState) {
    const formData = new FormData()
    formData.append('csv_file', file, 'csv_file.csv')
    formData.append('validation', validation)
    return fetch(`${config.URI}/api/v1/contacts_csv_import/${contactId}`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token
      },
      body: formData
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .catch(e => {
        console.error(e)
        isSentry(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/Contacts/actions/index.js